import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Product } from '../interfaces/product.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductcodeService {

  private getproductcodesUrl = environment.apiUrl + '/handlers/productgetall.php';
  private deleteproductcodeUrl = environment.apiUrl + '/handlers/productdelete.php';
  private updateproductcodeUrl = environment.apiUrl + '/handlers/productupdate.php';
  private createproductUrl = environment.apiUrl + '/handlers/productcreate.php';

  productcodes: Product[] = [];
  selectedProduct: Product= {} as Product;

  constructor(private http: HttpClient) { }

async getProductcodes(): Promise<Product[]> {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];
    const data$ = this.http.post<Product[]>(this.getproductcodesUrl,JSON.stringify({ distid: distid }))
    try {
          this.productcodes = await firstValueFrom(data$);
          return this.productcodes;
        }
        catch (error) {
          console.error('There was an error!', error);
          throw error;
        };  
  }

  async deleteProduct(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deleteproductcodeUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'Delete Product code Service Error: ', error);
              throw error;
    };  
   }  
     async updateProduct(id:number, description: string, description2: string, productcode: string, uom: string): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        try {
          const response$ = await firstValueFrom(this.http.post(this.updateproductcodeUrl, JSON.stringify({id,distid,description: description, description2: description2, productcode:productcode, uom:uom})));
           //return response$;
           return;
        }
        catch (error) {
          console.error(
            'Update product service error', error);
            throw error;
        };
    }

async create(description: string, description2: string, productcode: string, uom: string): Promise<any> {
    let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createproductUrl, JSON.stringify({description, description2, productcode, uom, distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'Error in create productcode service!', error);
             return;
         };  
  }

}
